import { config } from "./configs";

export const TENANT_KEY = config?.TENANT_KEY;
export const APIURL = config?.APIURL;
export const WEB_URL = config?.WEB_URL;
export const AWES_LOGO = config?.AWES_LOGO;
export const AWES_TAG_LINE = config?.AWES_TAG_LINE;
export const SCHOOL_DASHBOARD_URL = config?.SCHOOL_DASHBOARD_URL;
export const AWES_SCHOOL_DASHBOARD_URL = config?.AWES_SCHOOL_DASHBOARD_URL;

export const currentEventCode = "NARC-2023";
